/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { CollectionView } from 'backbone.marionette';

import SideNavLinkView from './SideNavLinkView';

import './SideNavLinkCollectionView.css';

const SideNavLinkCollectionView = CollectionView.extend({
  tagName: 'ul',

  className: 'side-nav-link-collection-view nav nav-pills list-group',

  attributes: {
    role: 'tablist',
    'aria-busy': true
  },

  childView: SideNavLinkView,

  initialize(options) {
    this.activeSectionExists = false;
    if (options.activeSectionId) {
      this.activeSectionExists = Boolean(this.collection.get(options.activeSectionId));
    }
  },

  childViewOptions(model) {
    let isLinkActive;
    if (this.activeSectionExists) {
      isLinkActive = model.id === this.options.activeSectionId;
    } else {
      // if this model is the first model, set it to the link to be active.
      const firstModel = this.collection.at(0);
      isLinkActive = firstModel.id === model.id;
    }
    return {
      isLinkActive
    };
  },

  childViewEvents: {
    'link:clicked': 'onChildLinkClicked'
  },

  getIndexOfId(id) {
    for (const [i, model] of this.collection.models.entries()) {
      if (model.get('id') === id) return i;
    }
    return null;
  },

  getActiveLinkIndex() {
    const child = this.children.find((child) => child.isActive());
    this.previousLinkIndex = this.collection.indexOf(child.model);
    return this.previousLinkIndex;
  },

  setActiveLinkByIndex(index) {
    _.each(this.children._views, (child, i) => {
      if (i === index) child.makeActive();
      else child.makeInactive();
    });
  },

  getActiveLinkId() {
    const child = this.children.find((child) => child.isActive());
    return child.model.id;
  },

  setActiveLinkById(id) {
    _.each(this.children._views, (child) => {
      if (child.model.id === id) child.makeActive();
      else child.makeInactive();
    });
  },

  setLoadingIndex(index) {
    this.children._views[index]?.setLoading();
  },

  setLoadedIndex(index) {
    this.children._views[index]?.setLoaded();
  },

  onChildLinkClicked(model) {
    const activeIndex = this.getIndexOfId(model.get('id'));
    const data = { linkIndex: activeIndex, previousLinkIndex: this.previousLinkIndex };
    this.triggerMethod('navlink:clicked', data);
  }
});

export default SideNavLinkCollectionView;
